"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderDetailComponent = void 0;
var OrderDetailComponent_1 = require("./OrderDetailComponent");
Object.defineProperty(exports, "OrderDetailComponent", { enumerable: true, get: function () { return OrderDetailComponent_1.OrderDetailComponent; } });
